import { pick, defaults, concat, reverse, keys } from 'lodash-es'

/**
 * @function getParams
 * @desc Override the values of params object by those found into the other objects. The keeped values are the lastest found.
 * @param {object}    params      - The parameters object.
 * @param {...object} [override]  - The override objects.
 * @return {string} The overriden params object.
 */
const getParams = function (params = {}) {
  const defaultParams = { page: 1, pageSize: 10, sort: null, search: null, fields: null }

  return pick(
    defaults.apply(this, concat([{}], reverse(arguments))), // override the values of the params object
    keys({ ...params, ...defaultParams }) // only keep values present into the params object
  )
}

export default getParams
